import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import WageList, { DispatchProps, OwnProps, StateProps } from './WageList';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import { getWages } from 'src/store/actions/wage-actions';
import { selectNameProviders } from '../../../../../../store/selectors/providers-selectors';
import { getProvidersSmall } from '../../../../../../store/actions/provider-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.wages.data,
        inProgress: state.wages.inProgress,
        providers: selectNameProviders(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getWages(params)),
        getProviders: (params) => dispatch(getProvidersSmall(params)),
    };
}

const WageListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(WageList);

export default WageListScreen;
